export default function AddAccont24({ color = "#FAFAFA" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0002 21.0000C2.0002 19.4604 2.4444 17.9534 3.2796 16.6599C4.1148 15.3665 5.3055 14.3415 6.7088 13.7080C8.1122 13.0746 9.6685 12.8595 11.1910 13.0887C12.7135 13.3179 14.1376 13.9815 15.2922 15.0000M19.0002 16.0001V22.0001M22.0002 19.0001H16.0002M15.0003 8.0000C15.0003 10.7614 12.7617 13.0000 10.0002 13.0000C7.2388 13.0000 5.0002 10.7614 5.0002 8.0000C5.0002 5.2386 7.2388 3.0000 10.0002 3.0000C12.7617 3.0000 15.0003 5.2386 15.0003 8.0000Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
